/**
 * Flatten a list of discount summary rows (each carrying its `children`) into a
 * single flat list of ClientDiscount rows for the "Client Discounts" lens.
 *
 * Each row is one per-TDRO realization (one client × discount). Parent context
 * (title / studio / format / territory / media) is denormalized onto each row
 * so the operator can sort or filter "all Apple deals", "all HD deals", or
 * "all Mufasa client deals" without leaving the flat list.
 *
 * The row keeps `parentDiscountId` so a click can still open the parent
 * discount's drawer for full context.
 */
export const buildClientDiscountRows = (discounts) => {
  const rows = [];
  for (const d of discounts || []) {
    for (const c of d.children || []) {
      rows.push({
        // Per-client realization fields (from the response's child shape)
        ...c,
        // Parent context — denormalized onto each row for sort / filter
        title: d.title,
        studio: d.studio,
        format: d.format,
        territory: d.territory,
        media: d.media,
        contentType: d.contentType,
        contentClassification: d.contentClassification,
        isBundle: d.isBundle,
        radarProductId: d.radarProductId,
        active: d.active,
        // Reference back to parent for the click-through
        parentDiscountId: d.id,
      });
    }
  }
  return rows;
};
